import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import merge from "lodash/merge";
import {
  fetchActivityHistory,
  FetchActivityHistoryParams,
  FetchActivityHistoryResponse
} from "PFCore/services/activity/activity_history";
import { Id, QueryOptions } from "PFTypes";

import { activityHistoryKeys } from "./query_keys";

const PER_PAGE = 10;

export const useActivityHistory = <TData = FetchActivityHistoryResponse>(
  activityId: Id,
  params?: FetchActivityHistoryParams,
  options?: QueryOptions<FetchActivityHistoryResponse, AxiosError, TData>
) => {
  const mergedParams = merge({ page: 1, perPage: PER_PAGE }, params);

  return useQuery<FetchActivityHistoryResponse, AxiosError, TData>({
    queryKey: activityHistoryKeys.list(activityId || "", mergedParams),
    queryFn: () => fetchActivityHistory(activityId, mergedParams),
    enabled: !!activityId,
    retry: false,
    placeholderData: keepPreviousData,
    ...options
  });
};
